export class DeleteFormErrorEffect {
  public static readonly type = '[Project/Forms/List] DeleteFormErrorEffect';
  constructor(public readonly error: Error) {}
}
